import { useState } from "react";
import PropTypes from "prop-types";

// constants
import { calendarDialogActions } from "constants/enums";

// use-http
import useFetch from "use-http";

// react mui
import { Dialog } from "@mui/material";

// dialogs
import DeleteAppointmentDialog from "./Dialogs/DeleteAppointment.dialog";
import DeleteAvailabilityDialog from "./Dialogs/DeleteAvailability.dialog";
import CreateAvailabilityDialog from "./Dialogs/CreateAvailability.dialog";

const FixedSlotsDialog = ({ onClose, open, slot, event, action }) => {
  const { post, error: creationError, del } = useFetch();

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleClose = () => {
    setSuccess(false);
    setLoading(false);
    setError(false);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      {action === calendarDialogActions.CREATEAVAILABILITY && (
        <CreateAvailabilityDialog
          post={post}
          creationError={creationError}
          handleClose={handleClose}
          loading={loading}
          setLoading={setLoading}
          success={success}
          setSuccess={setSuccess}
          error={error}
          setError={setError}
          slot={slot}
          event={event}
        />
      )}
      {action === calendarDialogActions.DELETEAVAILABILITY && (
        <DeleteAvailabilityDialog
          del={del}
          creationError={creationError}
          handleClose={handleClose}
          loading={loading}
          setLoading={setLoading}
          success={success}
          setSuccess={setSuccess}
          error={error}
          setError={setError}
          slot={slot}
        />
      )}
      {action === calendarDialogActions.DELETEAPPOINTMENT && (
        <DeleteAppointmentDialog
          del={del}
          creationError={creationError}
          handleClose={handleClose}
          loading={loading}
          setLoading={setLoading}
          success={success}
          setSuccess={setSuccess}
          error={error}
          setError={setError}
          slot={slot}
        />
      )}
    </Dialog>
  );
};
FixedSlotsDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  slot: PropTypes.array,
  event: PropTypes.object,
  action: PropTypes.string,
};
export { FixedSlotsDialog };
